import React, { Fragment } from 'react'
import { Dialog as HeadlessDialog, Transition } from '@headlessui/react'
import Button from 'components/Button'

interface DialogProps {
  isOpen: boolean
  onClose: () => unknown
  title: string
  description: string
  content?: React.ReactNode
  onSubmit?: () => unknown
  submitButtonlabel?: string
}

const Dialog = ({ isOpen, onClose, title, description, content, onSubmit, submitButtonlabel }: DialogProps) => {
  const handleSubmit = () => {
    onSubmit?.()
    onClose()
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <HeadlessDialog as='div' className='relative z-[100]' onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black/40 backdrop-blur-sm' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <HeadlessDialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                <HeadlessDialog.Title as='h3' className='text-lg font-medium leading-6 text-gray-900'>
                  {title}
                </HeadlessDialog.Title>
                <div className='mt-2'>
                  <p className='text-sm text-gray-500'>{description}</p>
                </div>

                {content}

                <div className='mt-4 w-full flex justify-end'>
                  <Button onClick={handleSubmit}>{submitButtonlabel || 'Fechar'}</Button>
                </div>
              </HeadlessDialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </HeadlessDialog>
    </Transition>
  )
}

export default Dialog
